import { RequestState } from "./../../App/types/common";
import { Action, ReducerMap } from "redux-actions";

import {
  PATCH_COURSE_FAILURE,
  PATCH_COURSE_IMPORT_TRANSLATIONS_FAILURE,
  PATCH_COURSE_IMPORT_TRANSLATIONS_SUCCESS,
  PATCH_COURSE_REQUEST,
  PATCH_COURSE_SUCCESS,
} from "../../actions/course-author/common";
import { IImportReport } from "../../api/CourseAuthorApi";
import { IFullCourse } from "../../components/course-author/types";

import { ICourseAuthorState } from "./types";

export type PatchCoursePayload = void | string | IFullCourse | IImportReport;

export const requestPatch = (state: ICourseAuthorState): ICourseAuthorState => ({
  ...state,
  importReport: null,
  patchCourseRequestError: null,
  patchCourseRequestState: RequestState.PENDING,
  updateCourseRequestError: null,
  updateCourseRequestState: RequestState.PENDING,
});

const requestPatchSuccess = (state: ICourseAuthorState, action: Action<IFullCourse>): ICourseAuthorState => ({
  ...state,
  course: action.payload,
  patchCourseRequestError: null,
  patchCourseRequestState: RequestState.SUCCEEDED,
  updateCourseRequestError: null,
  updateCourseRequestState: RequestState.SUCCEEDED,
});

const requestPatchFailure = (state: ICourseAuthorState, action: Action<string>): ICourseAuthorState => ({
  ...state,
  patchCourseRequestError: action.payload,
  patchCourseRequestState: RequestState.FAILED,
  updateCourseRequestError: action.payload,
  updateCourseRequestState: RequestState.FAILED,
});

const patchCourseImportTranslationsSuccess = (
  state: ICourseAuthorState,
  action: Action<IImportReport>
): ICourseAuthorState => ({
  ...state,
  importReport: action.payload,
});

const patchCourseImportTranslationsFailure = (
  state: ICourseAuthorState,
  action: Action<string>
): ICourseAuthorState => ({
  patchCourseImportTranslationsCsvFailure: action.payload,
  ...requestPatchFailure(state, action),
});

export const patchCourseReducer: ReducerMap<ICourseAuthorState, PatchCoursePayload> = {
  [PATCH_COURSE_REQUEST]: requestPatch,
  [PATCH_COURSE_SUCCESS]: requestPatchSuccess,
  [PATCH_COURSE_FAILURE]: requestPatchFailure,
  [PATCH_COURSE_IMPORT_TRANSLATIONS_SUCCESS]: patchCourseImportTranslationsSuccess,
  [PATCH_COURSE_IMPORT_TRANSLATIONS_FAILURE]: patchCourseImportTranslationsFailure,
};
